// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-telephone-table {
  margin: 20px 0;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  position: sticky;
  top: 0;
  z-index: 10;
}

.table-header h4 {
  margin: 0;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.add-row-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
  flex-shrink: 0;
  white-space: nowrap;
}

.add-row-btn:hover {
  background: #0056b3;
}

.empty-state {
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
}

.empty-state p {
  margin: 0 0 15px 0;
  font-size: 14px;
}

.add-first-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-first-btn:hover {
  background: #218838;
}

.table-container {
  overflow-x: auto;
}

.table-footer {
  padding: 15px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.add-hint {
  margin: 0 0 10px 0;
  color: #6c757d;
  font-size: 14px;
  font-style: italic;
}

.add-another-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.add-another-btn:hover {
  background: #218838;
}

.telephone-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.telephone-table th {
  background: #f8f9fa;
  padding: 12px 8px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
}

.telephone-table td {
  padding: 8px;
  border-bottom: 1px solid #e9ecef;
  vertical-align: top;
}

.telephone-table input,
.telephone-table select {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.telephone-table input:focus,
.telephone-table select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.telephone-table select {
  background: white;
}

.remove-btn {
  background: #dc3545;
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-btn:hover {
  background: #c82333;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.telephone-entry-row:hover {
  background-color: #f8f9fa;
}

.serial-number {
  text-align: center;
  font-weight: 600;
  color: #6c757d;
  background: #f8f9fa;
}

/* Responsive design */
@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  
  .telephone-table {
    font-size: 12px;
  }
  
  .telephone-table th,
  .telephone-table td {
    padding: 6px 4px;
  }
  
  .telephone-table input,
  .telephone-table select {
    font-size: 12px;
    padding: 4px 6px;
  }
}

/* Column widths for better layout */
.telephone-table th:nth-child(1),
.telephone-table td:nth-child(1) {
  width: 8%;
  min-width: 50px;
}

.telephone-table th:nth-child(2),
.telephone-table td:nth-child(2) {
  width: 20%;
  min-width: 120px;
}

.telephone-table th:nth-child(3),
.telephone-table td:nth-child(3) {
  width: 15%;
  min-width: 100px;
}

.telephone-table th:nth-child(4),
.telephone-table td:nth-child(4) {
  width: 35%;
  min-width: 150px;
}

.telephone-table th:nth-child(5),
.telephone-table td:nth-child(5) {
  width: 15%;
  min-width: 100px;
}

.telephone-table th:nth-child(6),
.telephone-table td:nth-child(6) {
  width: 7%;
  min-width: 50px;
  text-align: center;
} `, "",{"version":3,"sources":["webpack://./src/components/DynamicTelephoneTable.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,oCAAoC;AACpC;;EAEE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".dynamic-telephone-table {\n  margin: 20px 0;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.table-header h4 {\n  margin: 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.add-row-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.add-row-btn:hover {\n  background: #0056b3;\n}\n\n.empty-state {\n  padding: 40px 20px;\n  text-align: center;\n  color: #6c757d;\n}\n\n.empty-state p {\n  margin: 0 0 15px 0;\n  font-size: 14px;\n}\n\n.add-first-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.add-first-btn:hover {\n  background: #218838;\n}\n\n.table-container {\n  overflow-x: auto;\n}\n\n.table-footer {\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  text-align: center;\n}\n\n.add-hint {\n  margin: 0 0 10px 0;\n  color: #6c757d;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.add-another-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n\n.add-another-btn:hover {\n  background: #218838;\n}\n\n.telephone-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.telephone-table th {\n  background: #f8f9fa;\n  padding: 12px 8px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #dee2e6;\n  white-space: nowrap;\n}\n\n.telephone-table td {\n  padding: 8px;\n  border-bottom: 1px solid #e9ecef;\n  vertical-align: top;\n}\n\n.telephone-table input,\n.telephone-table select {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n}\n\n.telephone-table input:focus,\n.telephone-table select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.telephone-table select {\n  background: white;\n}\n\n.remove-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.remove-btn:hover {\n  background: #c82333;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 4px;\n  display: block;\n}\n\n.telephone-entry-row:hover {\n  background-color: #f8f9fa;\n}\n\n.serial-number {\n  text-align: center;\n  font-weight: 600;\n  color: #6c757d;\n  background: #f8f9fa;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .table-header {\n    flex-direction: column;\n    gap: 10px;\n    align-items: flex-start;\n  }\n  \n  .telephone-table {\n    font-size: 12px;\n  }\n  \n  .telephone-table th,\n  .telephone-table td {\n    padding: 6px 4px;\n  }\n  \n  .telephone-table input,\n  .telephone-table select {\n    font-size: 12px;\n    padding: 4px 6px;\n  }\n}\n\n/* Column widths for better layout */\n.telephone-table th:nth-child(1),\n.telephone-table td:nth-child(1) {\n  width: 8%;\n  min-width: 50px;\n}\n\n.telephone-table th:nth-child(2),\n.telephone-table td:nth-child(2) {\n  width: 20%;\n  min-width: 120px;\n}\n\n.telephone-table th:nth-child(3),\n.telephone-table td:nth-child(3) {\n  width: 15%;\n  min-width: 100px;\n}\n\n.telephone-table th:nth-child(4),\n.telephone-table td:nth-child(4) {\n  width: 35%;\n  min-width: 150px;\n}\n\n.telephone-table th:nth-child(5),\n.telephone-table td:nth-child(5) {\n  width: 15%;\n  min-width: 100px;\n}\n\n.telephone-table th:nth-child(6),\n.telephone-table td:nth-child(6) {\n  width: 7%;\n  min-width: 50px;\n  text-align: center;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
